import TlDictSelect from "./src/index.vue";

TlDictSelect.install = function (Vue) {
  Vue.component(TlDictSelect.name, TlDictSelect);
};

export default TlDictSelect;
